export default __webpack_public_path__ + "static/media/tt1.2e282598.png";